// Samwillbert Cloudflare Turnstile Site Key
// export const TURNSTILE_SITE_KEY = "0x4AAAAAAEe7tjWjfQ4PNhVK";

// Tiara Software Cloudflare Turnstile Site Key
export const TURNSTILE_SITE_KEY = "0x4AAAAAAEfIVJ0Dtt0tgIUD";
